import TopUpModel from '../models/topup.model';

let storeContent = utils.generateStore({
	showTopUpModal: false,
	showAccountsModal: false,
	showBalance: false,
	paySavedPaymentOption: false,
	TopUpModel,
	paymentTypes: [
		{ val: 'CARD', label: 'Card' },
		{ val: 'MOBILE', label: 'Mobile' },
	],
	currency: 'KES',
	accountData: {},
	mpesaData: {},
	stripe: null,
	cardElement: null,
	elements: null,
	currentPage: 1,
	channels: [],
	token: '',
	selectedPaymentOption: null,
	all_client_accounts: [],
	paybillText:
		'Use Paybill <b>323313</b>.<br> Generate ref to input as account number',
	generatedRef: '',
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async generateRef(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'transaction_ref',
						action: 'get',
						data: {
							amount: ctx.getters.accountData.amount,
							channel_code: payload.channel.channel_code,
							account_number:
								ctx.getters.accountData.account.account_number,
						},
					},
					'/client',
				);

				ctx.commit('loading', false);
				ctx.commit('generatedRef', res.result.tran_ref);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async checkoutStripe(ctx, payload) {
			try {
				ctx.commit('generatedRef', payload.token.id);
				ctx.commit('token', payload.token.id);
				ctx.commit('currentPage', 4);
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
			}
		},
		async fetchData(ctx, payload) {
			try {
				ctx.commit('generatedRef', '');
				await ctx.dispatch('fetchAccounts');
				await ctx.dispatch('fetchTopUpOptionsTopUp');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async changePaymentType(ctx, payload) {
			try {
				ctx.commit('channels', payload.option.tranchannel);
			} catch (err) {
				throw err;
			}
		},
		async moveToConfirmation(ctx, payload) {
			try {
				ctx.commit('currentPage', 4);
			} catch (err) {
				throw err;
			}
		},
		async goToPrevious(ctx) {
			try {
				if (ctx.getters.currentPage > 1) {
					ctx.commit('currentPage', ctx.getters.currentPage - 1);
				}
			} catch (err) {
				throw err;
			}
		},
		async moveToPaymentPage(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (payload.channel) {
					ctx.commit('currentPage', 3);
				} else {
					$notify(
						'warning',
						'Provide Channel',
						'Provide a channel',
						10,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async selectAccount(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'account',
							action: 'topup_options',
							data: {
								account_number: data.account.account_number,
							},
						},
						'/client',
					);
					ctx.commit(
						'paymentTypes',
						res.result.topup_options.system_topup_options,
					);
					ctx.commit('accountData', data);
					ctx.commit('currentPage', 2);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async checkoutMpesa(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					ctx.commit('mpesaData', data);
					ctx.commit('currentPage', 4);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async topUpSaved(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_,
					mobile = null;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'topup',
							action: 'add',
							data: {
								tran_amount: data.amount,
								channel_code:
									ctx.getters.selectedPaymentOption
										.channel_code,
								tran_channel_id:
									ctx.getters.selectedPaymentOption
										.tran_channel_id,
								topup_config_id:
									ctx.getters.selectedPaymentOption
										.ClientTopupOption_id,
								save_topup_option: false,
								category:
									ctx.getters.selectedPaymentOption.category,
								generated_transaction_ref:
									ctx.getters.selectedPaymentOption
										.generatedRef,
								account_number: data.account.account_number,
								thirdparty_provider:
									payload.channel.thirdparty_provider,
							},
						},
						'/client',
					);

					await ctx.dispatch('fetchAccounts');
					if (
						ctx.getters.selectedPaymentOption.channel_code ===
						'MPESA_CHECKOUT'
					) {
						$notify(
							'success',
							'Top Up Submitted',
							`An stk push was sent to saved mobile number`,
							10,
						);
					} else {
						$notify(
							'success',
							'Top Up Submitted',
							'Top up request successfully received',
							10,
						);
						ctx.commit('paySavedPaymentOption', false);
					}
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async topUp(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_,
					mobile = null;

				if (await payload.ref.isValid()) {
					if (
						ctx.getters.mpesaData.mobileNumber &&
						ctx.getters.mpesaData.mobileNumber.code
					) {
						mobile = `+${ctx.getters.mpesaData.mobileNumber.code.callingCode}${ctx.getters.mpesaData.mobileNumber.mobile}`;
					}
					let res = await api.fetchEndpointSecure(
						{
							resource: 'topup',
							action: 'add',
							data: {
								tran_amount: ctx.getters.accountData.amount,
								channel_code: payload.channel.channel_code,
								tran_channel_id:
									payload.channel.tran_channel_id,
								topup_config_id: payload.option.topup_config_id,
								save_topup_option: data.saveTopUp,
								category: payload.option.category,
								generated_transaction_ref:
									ctx.getters.generatedRef,
								contact: mobile,
								account_number:
									ctx.getters.accountData.account
										.account_number,
								thirdparty_provider:
									payload.channel.thirdparty_provider,
							},
						},
						'/client',
					);

					if (payload.channel.channel_code === 'MPESA_CHECKOUT') {
						$notify(
							'success',
							'Top Up Submitted',
							`An stk push was sent to <b>${mobile}</b>`,
							10,
						);
						// ctx.commit('showTopUpModal',false)
					} else {
						$notify(
							'success',
							'Top Up Submitted',
							'Top up request successfully received',
							10,
						);
						ctx.commit('showTopUpModal', false);
					}
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchAccounts(ctx) {
			try {
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'get',
						data: {},
					},
					'/client',
				);
				ctx.commit('all_client_accounts', res.result.client_accounts);

				let form = utils.appendSelectData({
					form: TopUpModel.forms.account_details,
					model: 'account',
					label: 'account_type',
					$labelSupport: 'currency_code',
					$label: 'available_balance',
					data: res.result.client_accounts,
				});

				if (form) {
					let Model = ctx.getters.TopUpModel;
					Model.forms.account_details = form;
					ctx.commit('TopUpModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
		async selectFieldChanged(ctx, payload) {
			try {
				if (payload.form.model === 'top_up_options' && payload.data) {
					ctx.commit('selectedPaymentOption', payload.data);
					ctx.commit('paySavedPaymentOption', true);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchTopUpOptionsTopUp(ctx) {
			try {
				if (ctx.getters.all_client_accounts.length == 0) {
					return false;
				}

				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'topup_options',
						data: {
							account_number:
								ctx.getters.all_client_accounts[0]
									.account_number,
							amount: 0,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: TopUpModel.forms.saved_top_up_options,
					model: 'top_up_options',
					label: 'channel_name',
					data: res.result.topup_options.account_topup_options,
				});

				if (form) {
					let Model = ctx.getters.TopUpModel;
					Model.forms.saved_top_up_options = form;
					ctx.commit('TopUpModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
	},
};
